export const getGridInititalState = (gridName, inititalGridConfig = null) => {
  return {
    gridName,
    gridConfig: {
      columnModel: inititalGridConfig?.columnModel ?? [],
      rowGroupKey: inititalGridConfig?.rowGroupKey ?? null,
      filterModel: inititalGridConfig?.filterModel ?? {},
      selection: inititalGridConfig?.selection ?? {
        allSelected: false,
        toggledNodes: [],
        selectedCount: 0,
        unselectableRowCount: 0,
        // Tree data selection counts (parent/child breakdown)
        treeChildCount: null,
      },
      rowCount: inititalGridConfig?.rowCount ?? 0,
      hashes: {},
      rowData: inititalGridConfig?.rowData ?? [],
      initialScrollPosition: inititalGridConfig?.initialScrollPosition ?? 0,
    },
  };
};
